













import { Vue, Component, Prop, Watch } from "../../Infrastructure/CorBase/CoreBase";

@Component
export default class BaseTLSpinner extends Vue {
	@Prop({ type: String, required: false, default: "Načítám" }) label?: string; //hlavní popis
	@Prop({ type: Boolean, required: false, default: null }) isBusy?: boolean; //visibilita spinneru
	@Prop({ type: Boolean, required: false, default: true }) startAfter?: boolean; //spusteni hned po startu

	// prijde mi to zbytecne, je potreba to ridit pomoci isBusy i pri startu
	//zobrazeni hned po startu
	created() {
		if (this.startAfter) {
			this.$nextTick(function () {
				this.$bvModal.show('spinnerId');
			})
		}
	}

	@Watch('isBusy')
	onPropertyChanged(value: boolean, oldValue: boolean) {
		if (value !== oldValue) {
			if (value == true) {
				this.$bvModal.show('spinnerId');
			}
			else {
				this.$bvModal.hide('spinnerId');
			}
		}
	}

}
